import { useState } from "react";
import Paper from "@mui/material/Paper";
import { Box, Container } from "@mui/material";
import CustomText from "components/common/CustomText/CustomText";
import { colors } from "styles/colors";
import CustomButton from "components/buttons/CustomButton/CustomButton";
import useGlobalStyles from "styles/globalStyles";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CropFreeIcon from "@mui/icons-material/CropFree";
import { useCheckWhatsapp } from "hooks/useWaha";

export default function WhatsappContent() {
  const globalStyles = useGlobalStyles();
  const [imageUrl, setImageUrl] = useState<string | null>(null);

  const { refetch, isLoading } = useCheckWhatsapp({
    enabled: false,
    onSuccess: (blob: Blob) => {
      const url = URL.createObjectURL(blob);
      setImageUrl(url);
    },

    onError: (err: any) => {
      console.log("error", err);
    },
  });

  const checkWhatsapp = () => {
    refetch();
  };

  return (
    <Container disableGutters maxWidth={"xl"}>
      <Paper
        className={globalStyles.tableContainer}
        sx={{
          overflowX: "auto",
          minHeight: 11 * 52 + 56,
        }}
      >
        {/* Header */}
        <Box
          display={{ sm: "block", md: "flex" }}
          justifyContent={"space-between"}
          gap={2}
          sx={{
            px: 2,
            py: 2.5,
            borderBottom: "1px solid",
            borderColor: "divider",
          }}
        >
          <Box display="flex" alignItems="center" gap={1.5}>
            <Box
              sx={{
                backgroundColor: colors.topBackground,
                display: "inline-flex",
                height: 40,
                width: 40,
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
              }}
            >
              <WhatsAppIcon sx={{ color: colors.primary, fontSize: 22 }} />
            </Box>
            <CustomText
              text="Whatsapp"
              fontSize={16}
              color={colors.primary}
              fontWeight={600}
            />
          </Box>

          <CustomButton
            text="Screenshot"
            height={40}
            icon={<CropFreeIcon />}
            onClick={checkWhatsapp}
            loading={isLoading}
            disabled={isLoading}
          />
        </Box>

        {/* Image */}
        <Box p={3}>
          {imageUrl ? (
            <img
              src={imageUrl}
              alt="Whatsapp Screenshot"
              style={{ maxWidth: "100%" }}
            />
          ) : (
            <CustomText text="No screenshot yet" />
          )}
        </Box>
      </Paper>

      <Box mt={3} />
    </Container>
  );
}
